import React, { useContext } from "react";
import "./About_banner.css";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";

function About_banner() {
  const { language } = useContext(Context);

  return (
    <>
      <section className="About_banner">
        <div className="vdo_holder">
          <video
            src="/assets/video/about_us/banenr_vdo.mp4"
            autoPlay
            loop
            muted
            alt="banner vdo"
            className="banner_vdo"
          />
        </div>
        <div className="banner_content_holder">
          <div className="container">
            <div className="heading_hodler">
              <h2>
                {language == 1
                  ? "We Nurture Talent"
                  : "Nous développons les talents"}
              </h2>

              <h1>
                {language == 1 ? "ACROSS THE GLOBE" : "À TRAVERS LE MONDE"}
              </h1>

              <p>
                {language == 1
                  ? "Seamlessly apply, hire, and manage every step of the internship process with confidence."
                  : "Postulez, recrutez et gérez chaque étape du processus de stage en toute confiance."}
              </p>

              <Link to={"/contact-us"}>
                <Button className="Get_In_Touch">
                  {language == 1 ? "Get In Touch" : "Nous contacter"}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About_banner;
